module.exports = __webpack_public_path__ + "img/Small_edith.62853d4b.png";